module.exports = __webpack_public_path__ + "img/id-pay-redirect.svg";